import {
  errorBillingArray,
  errorDefault,
  errorDefaultCartEmpty,
  errorDefaultDelivery,
  errorDefaultDemand,
  errorDefaultGiftCard,
  errorDefaultPayment,
  errorDefaultShipping,
  ErrorTypeBilling
} from './error-handler.constants';
import type {
  IErrorHandlerBilling,
  IErrorResponse
} from './error-handler.interfaces';

export const errorHandlerBilling = (
  originError?: IErrorResponse
): IErrorHandlerBilling => {
  if (!originError) return errorDefault;

  if (originError?.error?.meta?.cartId) {
    originError.error.meta.cartId = '';
  }
  const errorStringWithoutCartId = JSON.stringify(originError);

  const error = errorBillingArray?.find((elm) =>
    errorStringWithoutCartId.includes(elm?.originError || elm?.errorCode || '')
  );

  if (error) return error;

  if (originError?.error?.meta?.errorCode?.includes('CHK')) {
    const errorMap = errorDefaultPayment;
    errorMap.errorCode = originError?.error?.meta?.errorCode;
    return errorMap;
  }

  switch (originError?.error?.type) {
    case ErrorTypeBilling.DELIVERY:
      return errorDefaultDelivery;
    case ErrorTypeBilling.PAYMENT:
      return errorDefaultPayment;
    case ErrorTypeBilling.SHIPPING:
      return errorDefaultShipping;
    case ErrorTypeBilling.DEMAND:
      return errorDefaultDemand;
    case ErrorTypeBilling.GIFTCARD:
      return errorDefaultGiftCard;
    case ErrorTypeBilling.CART_IS_EMPTY:
      return errorDefaultCartEmpty;
    default:
      return errorDefault;
  }
};
